import { ReactNode } from 'react'
import { useAppSelector } from '../../hooks/redux'
import { Navigate } from 'react-router-dom'

const AuthRedirect = ({ children }: { children: ReactNode }) => {
    const { user } = useAppSelector((state) => state.user)
    if (user) {
        return <Navigate to="/" replace />
    }
    return <>{children}</>
}

export default AuthRedirect 